module.exports = __webpack_public_path__ + "static/media/cyborg1.80b743e5.png";